<template>
  <div class="cplan-card-outer">
    <div class="cplan-completed-unit-card">
      <div class="cplan-completed-unit-card__code">{{unit.code}}</div>
      <div class="cplan-completed-unit-card__title">
        <button type="button" class="btn-link-bold" v-on:click="clickUnitTitle">{{unit.name}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SlideOutUnitDetailsView from '../select-units/slide-out-tree-view/SlideOutUnitDetailsView.vue'

export default {
  props: {
    unit: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      slideOutComponent: SlideOutUnitDetailsView
    }
  },
  computed: {
    labelClass() {
      return `unit-${this.unit.firstLevelTitle.toLowerCase().replace(/\s/gi, '-')}`
    }
  },
  methods: {
    ...mapMutations('global', {
      openSlideOut: 'openSlideOut'
    }),
    // in order for the slideout to work, we need the following fields
    // location,
    clickUnitTitle() {
      this.openSlideOut({
        component: this.slideOutComponent,
        componentProperties: { relationship: this.unit, location: this.unit.name, firstLevelTitle: this.unit.firstLevelTitle, reviewMode: true }
      })
    }
  },
}
</script>
